import { FormatEmployeeLabelValue } from "./FormatEmployeeLabelValue";
import { Globals } from "../CoreApp/Globals";

export function FormatEmployeeDictLabel(theDict, mapping, returnParts, fieldIdList) {
  //TODO: This should really be replaced/deprecated by making these real DB objects and going through the other
  //version of this method
  if (!theDict) return "";

  if (!fieldIdList) fieldIdList = Globals._uiConfig.fEmployeelabelFields;
  var formattedString = "";
  var n = fieldIdList?.length;
  var primaryString = null;
  for (var index = 0; index < n; index++) {
    var theField = fieldIdList[index];
    var fieldValue = theDict[theField];
    if (!fieldValue) fieldValue = theDict[mapping[theField]];
    if (index === 0) primaryString = fieldValue;
    formattedString = FormatEmployeeLabelValue(formattedString, fieldValue, index, index === n - 1);
  }
  if (returnParts) return { primary: primaryString, full: formattedString };
  return formattedString;
}
